var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"  all"),React.createElement("g",{"data-name":"Zoom In","key":1},React.createElement("g",{"data-name":"Calendar"},[React.createElement("path",{"d":"M56.7 76.6H43.3v-33H56.7v33ZM50 38.1a7.3 7.3 0 1 1 7.3-7.3A7.3 7.3 0 0 1 50 38.1Z","key":0}),React.createElement("path",{"d":"M85.4 14.6a50 50 0 1 0 0 70.7A49.8 49.8 0 0 0 85.4 14.6ZM79.8 79.8A42.2 42.2 0 0 1 20.2 20.2a42.2 42.2 0 0 1 59.7 0h0A42.2 42.2 0 0 1 79.8 79.8Z","key":1}),React.createElement("circle",{"cx":"50","cy":"30.7","r":"7.3","key":2}),React.createElement("rect",{"x":"43.3","y":"43.6","width":"13.4","height":"33","key":3})]))]);
}

Info.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Info;

Info.default = Info;
